import { registerAnimation } from 'react-native-animatable';

registerAnimation('none', {});
export default {};
